// Formulaire produit : variantes et paliers (données pré-rendues en Liquid), options payantes,
// produit complémentaire et ajout groupé au panier via window.MpPanier (mp-cart.js).
//
// Événements émis (document) :
// - mp:variante:change { sectionId, variante }
// - mp:palier:change   { sectionId, quantite, index }
// - mp:panier:ajoute   { sectionId, articles, panier }
// (mp:panier:maj est émis par MpPanier)
if (!customElements.get('mp-produit')) {
  class MpProduit extends HTMLElement {
    connectedCallback() {
      const donnees = this.querySelector('[data-mp-variantes]');
      this.variantes = donnees ? JSON.parse(donnees.textContent) : [];
      this.form = this.querySelector('[data-mp-form]');
      this.inputId = this.querySelector('[data-mp-variante-id]');
      this.inputQuantite = this.querySelector('[data-mp-quantite]');
      this.bouton = this.querySelector('[data-mp-atc]');
      this.erreur = this.querySelector('[data-mp-erreur]');
      this.paliers = [...this.querySelectorAll('[data-mp-palier]')];
      this.optionsPayantes = [...this.querySelectorAll('[data-mp-option-payante]')];

      this.addEventListener('change', (event) => {
        const cible = event.target;
        if (cible.matches('[data-mp-option]')) this.surChangementOption();
        else if (cible.matches('[data-mp-palier]')) this.surChangementPalier(cible);
        else if (cible.matches('[data-mp-option-payante]')) this.surChangementOptionPayante(cible);
      });
      this.form?.addEventListener('submit', (event) => this.ajouterAuPanier(event));

      this.verifierActivite();
      this.majDisponibiliteOptions(this.optionsChoisies());
      this.majPaliers(this.varianteCourante);

      // Offres : choix couleur / taille article par article
      this.addEventListener('change', (event) => {
        const menu = event.target.closest('[data-mp-lot-option]');
        if (!menu) return;
        const ligne = menu.closest('[data-mp-lot-ligne]');
        ligne.dataset.touche = 'true';
        this.majLigneLot(ligne);
      });

      // Options payantes : l'état coché reflète le panier réel (jamais pré-cochées par le thème)
      if (this.optionsPayantes.length > 0) {
        this.surMajPanier = (event) => this.synchroniserOptions(event.detail.panier);
        document.addEventListener('mp:panier:maj', this.surMajPanier);
        window.MpPanier?.obtenir().then((panier) => this.synchroniserOptions(panier)).catch(() => {});
      }
    }

    disconnectedCallback() {
      if (this.surMajPanier) document.removeEventListener('mp:panier:maj', this.surMajPanier);
    }

    get sectionId() {
      return this.dataset.section;
    }

    get varianteCourante() {
      const id = Number(this.inputId?.value);
      return this.variantes.find((v) => v.id === id);
    }

    get quantite() {
      return Number(this.inputQuantite?.value) || 1;
    }

    /* ---------- Variantes ---------- */

    optionsChoisies() {
      return [...this.querySelectorAll('[data-mp-option-groupe]')].map(
        (groupe) => groupe.querySelector('[data-mp-option]:checked')?.value
      );
    }

    surChangementOption() {
      const options = this.optionsChoisies();
      const variante = this.variantes.find((v) => v.options.every((valeur, i) => valeur === options[i]));

      this.querySelectorAll('[data-mp-option-groupe]').forEach((groupe, i) => {
        const choix = groupe.querySelector('[data-mp-option-choix]');
        if (choix) choix.textContent = options[i];
      });
      this.majDisponibiliteOptions(options);
      this.appliquerVariante(variante);
    }

    // Grise les valeurs qui, combinées aux autres options choisies, ne donnent aucune variante disponible
    majDisponibiliteOptions(options) {
      this.querySelectorAll('[data-mp-option-groupe]').forEach((groupe, indexGroupe) => {
        groupe.querySelectorAll('[data-mp-option]').forEach((input) => {
          const disponible = this.variantes.some(
            (v) =>
              v.disponible &&
              v.options.every((valeur, i) => (i === indexGroupe ? valeur === input.value : valeur === options[i]))
          );
          this.querySelector(`label[for="${input.id}"]`)?.classList.toggle('is-indisponible', !disponible);
        });
      });
    }

    appliquerVariante(variante) {
      this.masquerErreur();

      if (!variante) {
        this.majBouton(false, this.bouton?.dataset.libelleIndisponible);
        return;
      }

      if (this.inputId) this.inputId.value = variante.id;
      this.querySelectorAll('[data-mp-maj="prix"]').forEach((el) => (el.innerHTML = variante.prix));
      this.querySelectorAll('[data-mp-maj="stock"]').forEach((el) => (el.innerHTML = variante.stock));
      this.majPaliers(variante);
      this.majImagesPaliers(variante);
      this.alignerLots(variante);
      this.majBouton(
        variante.disponible,
        variante.disponible ? this.bouton?.dataset.libelleAjouter : this.bouton?.dataset.libelleEpuise
      );

      if (this.hasAttribute('data-maj-url')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variante.id);
        window.history.replaceState({}, '', url);
      }

      document.dispatchEvent(
        new CustomEvent('mp:variante:change', { detail: { sectionId: this.sectionId, variante } })
      );
    }

    // Lignes du lot jamais modifiées à la main : elles suivent la couleur / taille choisie en haut
    alignerLots(variante) {
      this.querySelectorAll('[data-mp-lot-ligne]').forEach((ligne) => {
        if (ligne.dataset.touche) return;
        ligne.querySelectorAll('[data-mp-lot-option]').forEach((menu) => {
          const valeur = variante.options[Number(menu.dataset.mpLotOption)];
          if (valeur !== undefined) menu.value = valeur;
        });
        this.majLigneLot(ligne);
      });
    }

    varianteDeLigne(ligne) {
      const choix = [];
      ligne.querySelectorAll('[data-mp-lot-option]').forEach((menu) => {
        choix[Number(menu.dataset.mpLotOption)] = menu.value;
      });
      return this.variantes.find((v) => v.options.every((valeur, i) => valeur === choix[i]));
    }

    majLigneLot(ligne) {
      const variante = this.varianteDeLigne(ligne);
      const image = ligne.querySelector('[data-mp-lot-image]');
      if (variante?.image_palier && image && image.getAttribute('src') !== variante.image_palier) {
        image.srcset = variante.image_palier_srcset || '';
        image.src = variante.image_palier;
      }
      ligne.classList.toggle('is-indisponible', !variante?.disponible);
    }

    // Articles du lot sélectionné (null si l'offre n'a pas de choix article par article)
    articlesDuLot() {
      const carte = this.querySelector('.mp-palier:has(.mp-palier__input:checked)');
      const lot = carte?.querySelector('[data-mp-lot]');
      if (!lot) return null;
      const payes = new Map();
      const offerts = new Map();
      for (const ligne of lot.querySelectorAll('[data-mp-lot-ligne]')) {
        const variante = this.varianteDeLigne(ligne);
        if (!variante?.disponible) throw new Error(this.erreur?.dataset.defaut || 'Une des tailles choisies est indisponible.');
        const cible = ligne.hasAttribute('data-offert') ? offerts : payes;
        cible.set(variante.id, (cible.get(variante.id) || 0) + 1);
      }
      return [
        ...[...payes].map(([id, quantity]) => ({ id, quantity })),
        ...[...offerts].map(([id, quantity]) => ({ id, quantity, properties: { _offert: '1' } })),
      ];
    }

    // Offres : photo de la couleur choisie
    majImagesPaliers(variante) {
      if (!variante.image_palier) return;
      this.querySelectorAll('[data-mp-palier-image]').forEach((image) => {
        if (image.getAttribute('src') === variante.image_palier) return;
        image.srcset = variante.image_palier_srcset || '';
        image.src = variante.image_palier;
      });
    }

    majBouton(actif, libelle) {
      if (!this.bouton) return;
      this.bouton.disabled = !actif;
      const cible = this.bouton.querySelector('[data-mp-atc-libelle]');
      if (cible && libelle) cible.textContent = libelle;
    }

    /* ---------- Paliers ---------- */

    // Prix des paliers pour la variante + désactivation des paliers au-delà du stock réel
    majPaliers(variante) {
      if (!variante || this.paliers.length === 0) return;

      this.paliers.forEach((input) => {
        const index = Number(input.dataset.index);
        const zonePrix = this.querySelector(`[data-mp-palier-prix="${index}"]`);
        if (zonePrix && variante.paliers?.[index] !== undefined) zonePrix.innerHTML = variante.paliers[index];

        const horsStock = variante.stock_max !== null && Number(input.value) > variante.stock_max;
        input.disabled = horsStock || Boolean(input.closest('.mp-palier--epuisee'));
        input.closest('.mp-palier')?.classList.toggle('is-indisponible', horsStock);
      });

      const coche = this.paliers.find((input) => input.checked);
      if (coche?.disabled) {
        const repli = [...this.paliers].reverse().find((input) => !input.disabled);
        if (repli) {
          repli.checked = true;
          this.surChangementPalier(repli);
        }
      }
    }

    surChangementPalier(input) {
      if (this.inputQuantite) this.inputQuantite.value = input.value;
      document.dispatchEvent(
        new CustomEvent('mp:palier:change', {
          detail: { sectionId: this.sectionId, quantite: Number(input.value), index: Number(input.dataset.index) },
        })
      );
    }

    /* ---------- Options payantes ---------- */

    // Les options sont rendues dans chaque carte de lot : seules celles de la
    // carte sélectionnée sont visibles, et donc les seules à envoyer au panier.
    get optionsActives() {
      const carte = this.querySelector('.mp-palier:has(.mp-palier__input:checked)');
      const zone = carte?.querySelector('[data-mp-options-carte]');
      return zone ? [...zone.querySelectorAll('[data-mp-option-payante]')] : this.optionsPayantes;
    }

    // Un choix fait dans une carte vaut pour toutes : on le recopie sur les jumelles
    refleterOption(input) {
      this.optionsPayantes.forEach((autre) => {
        if (autre !== input && autre.value === input.value) autre.checked = input.checked;
      });
    }


    synchroniserOptions(panier) {
      if (!panier || !window.MpPanier) return;
      // Sans produit principal dans le panier, on respecte le choix en cours du visiteur
      if (!window.MpPanier.articlePrincipalPresent(panier)) return;
      this.optionsPayantes.forEach((input) => {
        input.checked = Boolean(window.MpPanier.trouverVariante(panier, input.value));
      });
    }

    // Si le produit est déjà au panier, l'option est ajoutée/retirée tout de suite ; sinon elle part avec l'ajout
    async surChangementOptionPayante(input) {
      this.refleterOption(input);
      if (!window.MpPanier) return;
      input.disabled = true;
      try {
        const panier = await window.MpPanier.obtenir();
        if (!window.MpPanier.articlePrincipalPresent(panier)) return;
        const present = window.MpPanier.trouverVariante(panier, input.value);
        if (input.checked && !present) await window.MpPanier.ajouter([{ id: Number(input.value), quantity: 1 }]);
        if (!input.checked && present) await window.MpPanier.changer(present.key, 0);
      } catch (erreur) {
        input.checked = !input.checked;
        this.afficherErreur(erreur.message);
      } finally {
        input.disabled = false;
      }
    }

    /* ---------- Ajout au panier ---------- */

    async ajouterAuPanier(event) {
      event.preventDefault();
      if (!this.bouton || this.bouton.disabled || !window.MpPanier) return;

      const variante = this.varianteCourante;
      if (!variante?.disponible) return;

      this.masquerErreur();
      this.bouton.setAttribute('aria-busy', 'true');
      this.bouton.disabled = true;

      try {
        const panierActuel = await window.MpPanier.obtenir();
        // Offres « 3 achetés = 1 offert » : 1 unité sur 4 va sur une ligne « _offert », dont la taille et
        // la couleur se choisissent ensuite dans le tiroir panier
        let articles = this.articlesDuLot();
        if (!articles) {
          const offerts = this.querySelector('.mp-palier') ? Math.floor(this.quantite / 4) : 0;
          articles = [{ id: variante.id, quantity: this.quantite - offerts }];
          if (offerts > 0) articles.push({ id: variante.id, quantity: offerts, properties: { _offert: '1' } });
        }

        const complementaire = this.querySelector('[data-mp-complementaire]:checked');
        if (complementaire) articles.push({ id: Number(complementaire.value), quantity: 1 });

        this.optionsActives.forEach((input) => {
          if (input.checked && !window.MpPanier.trouverVariante(panierActuel, input.value)) {
            articles.push({ id: Number(input.value), quantity: 1 });
          }
        });

        const detail = { articles };
        this.dispatchEvent(new CustomEvent('mp:produit:avant-ajout', { detail }));

        const panier = await window.MpPanier.ajouter(detail.articles);
        document.dispatchEvent(
          new CustomEvent('mp:panier:ajoute', { detail: { sectionId: this.sectionId, articles: detail.articles, panier } })
        );

        // Sans tiroir panier sur la page : aller au panier
        if (!document.querySelector('mp-tiroir-panier')) {
          window.location.href = `${window.mpConfig?.racine || '/'}cart`;
        }
      } catch (erreur) {
        this.afficherErreur(erreur.message);
      } finally {
        this.bouton.removeAttribute('aria-busy');
        this.bouton.disabled = !this.varianteCourante?.disponible;
      }
    }

    afficherErreur(message) {
      if (!this.erreur) return;
      this.erreur.textContent = message || this.erreur.dataset.defaut || '';
      this.erreur.hidden = false;
    }

    masquerErreur() {
      if (!this.erreur) return;
      this.erreur.hidden = true;
      this.erreur.textContent = '';
    }

    // La page peut être servie depuis le cache : on masque les ventes du jour si la date a changé
    verifierActivite() {
      const activite = this.querySelector('[data-mp-activite]');
      if (!activite) return;
      const correspondance = /^([+-])(\d{2})(\d{2})$/.exec(activite.dataset.decalage || '');
      if (!correspondance) return;
      const signe = correspondance[1] === '-' ? -1 : 1;
      const decalage = signe * (Number(correspondance[2]) * 60 + Number(correspondance[3]));
      const jourBoutique = new Date(Date.now() + decalage * 60000).toISOString().slice(0, 10);
      if (jourBoutique !== activite.dataset.jour) activite.hidden = true;
    }
  }

  customElements.define('mp-produit', MpProduit);
}
